module.exports = __webpack_public_path__ + "static/fonts/element-icons.27c72091.ttf";